<template>
  <button
    class="sc-btn"
    :type="type"
    :disabled="disabled"
    :class="[
      btnVariant,
      btnSize,
      btnOutlined,
      btnBlocked,
      btnRounded,
      btnSquared
    ]"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "AppButton",
  props: {
    type: {
      type: String,
      default: "button"
    },
    variant: {
      type: String,
      default: "primary"
    },
    size: {
      type: String,
      default: "md"
    },
    outlined: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    square: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    btnVariant() {
      return this.variant === "primary" ||
        this.variant === "secondary" ||
        this.variant === "card" ||
        this.variant === "danger" ||
        this.variant === "link"
        ? `sc-btn-${this.variant}`
        : "sc-btn-primary";
    },
    btnSize() {
      return this.size === "sm" || this.size === "md" || this.size === "lg"
        ? `sc-btn-${this.size}`
        : "sc-btn-md";
    },
    btnOutlined() {
      return this.outlined ? `sc-btn-outline-${this.variant}` : "";
    },
    btnBlocked() {
      return this.block ? "btn-block" : "";
    },
    btnRounded() {
      return this.rounded ? "sc-btn-rounded" : "";
    },
    btnSquared() {
      return this.square ? "sc-btn-square" : "";
    }
  }
};
</script>
